



















import { Component, Ref, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Timeline extends Vue {
  @Prop() timelineList!: string[]
  @Prop() currentPosition: number = 0
  @Ref('itemRefs')
  readonly itemRefs!: HTMLSpanElement[]
  get computedCurrentItem () {
    return this.currentPosition
  }

  getActiveClass (index: number) {
    return { 'timeline--item--button': true, 'timeline--item__active': (index === this.computedCurrentItem) }
  }

  @Watch('currentPosition')
  setCurrentItem () {
    const currentElement = this.itemRefs[this.currentPosition]
    currentElement.scrollIntoView({ behavior: 'smooth', block: 'end' })
  }

  selectTimeFrame (index: number) {
    this.$emit('timeSelected', { position: index })
  }
}
